import React from 'react'
import { useTranslation } from 'react-i18next'
import { faCalendarClock } from '@fortawesome/pro-regular-svg-icons'

import { FaIcon } from '../../../App/Components'
import { CustomerPunchCard } from '../../types'
import {
  PunchCardBlock,
  PunchCardBlockHeader,
} from '../PunchCardConfirmBlock/style'
import {
  ExpiredMessage,
  ExpiredCardRow,
  ExpiredCardName,
  ExpiredCardExpiry,
  ExpiredCardExpiryText,
} from './style'

type Props = {
  cards: CustomerPunchCard[]
  highlightColor: string
  fontColor: string
}

export const PunchCardExpiredBlock = ({
  cards,
  highlightColor,
  fontColor,
}: Props) => {
  const { t } = useTranslation()

  if (!cards || cards.length === 0) return null

  return (
    <PunchCardBlock highlightcolor={highlightColor}>
      <PunchCardBlockHeader fontcolor={fontColor}>
        {t('Unused Punch Card')}
      </PunchCardBlockHeader>
      <ExpiredMessage fontcolor={fontColor}>
        {t(
          'Your current appointment cannot be linked to your punch card because it will have expired.'
        )}
      </ExpiredMessage>
      {cards.map((card) => (
        <ExpiredCardRow key={card.uuid}>
          <ExpiredCardName fontcolor={fontColor}>{card.name}</ExpiredCardName>
          {card.expires_at && (
            <ExpiredCardExpiry>
              <FaIcon size="xs" icon={faCalendarClock} color={fontColor} />
              <ExpiredCardExpiryText fontcolor={fontColor}>
                {new Date(card.expires_at).toLocaleDateString()}
              </ExpiredCardExpiryText>
            </ExpiredCardExpiry>
          )}
        </ExpiredCardRow>
      ))}
    </PunchCardBlock>
  )
}
